import React, { useState, useEffect } from "react";
import { Modal, Form, Input, InputNumber, Button, notification } from "antd";
import { axiosPost } from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";

interface FarePreview {
    fare: number;
    duration: number;
    distance: number;
}

interface TripCloseProps {
  visible: boolean;
  hideModal: (val: boolean) => void;
  selectedRowData: any[];
  farePreview: FarePreview | null;
  title?: string;
}

const Tripclose: React.FC<TripCloseProps> = ({
  visible,
  hideModal,
  selectedRowData,
  farePreview,
  title,
}) => {
  const [form] = Form.useForm();
  const [selectedRowInfo, setSelectedRowInfo] = useState<any>({});
  const [creditChecked, setCreditChecked] = useState(false);

  const roleid = localStorage.getItem("roleid");
  const employeename = localStorage.getItem("employeename");

  // Set selected row
  useEffect(() => {
    if (selectedRowData?.length > 0) {
      setSelectedRowInfo(selectedRowData[0]);
    }
  }, [selectedRowData]);

  // Populate form when farePreview changes
  useEffect(() => {
    if (farePreview) {
      form.setFieldsValue({
        km: farePreview.distance,
        time: farePreview.duration,
        fare: farePreview.fare,
      });
    }
  }, [farePreview]);

  const handleCancel = () => {
    hideModal(false);
    form.resetFields();
  };

  const openNotificationWithIcon = (type: "success" | "error", message: string) => {
    notification[type]({ message });
  };

  const completetrip = (values: any) => {
    const options = {
      data: {
        cabid: selectedRowInfo?.cabid,
        bookingid: selectedRowInfo?.id,
        completedby:`${employeename}-A`,
        distance: farePreview?.distance,
        mins: farePreview?.duration,
        fare: farePreview?.fare,
        feedback: selectedRowInfo?.feedback,
        piclat: selectedRowInfo?.toloclat,
        piclon: selectedRowInfo?.toloclong,
        present_location: selectedRowInfo?.toloc,
        isadditionalfare: false,
        iscredit: creditChecked,
      },
    };

    axiosPost(UrlConstants.tripComplete, options)
      .then(() => {
        openNotificationWithIcon("success", "Trip Completed Successfully");
        handleCancel();
      })
      .catch(() => {
        openNotificationWithIcon("error", "Failed to complete trip");
      });
  };

  return (
    <Modal
      destroyOnClose
      className="custom-modal-form"
      title={title}
      width={420}
      visible={visible}   
      onCancel={handleCancel}
      footer={null}
    >
      <Form
        form={form}   
        layout="horizontal"
      >
        <Form.Item label="Booking Id">
          <Input value={selectedRowInfo?.id} readOnly />
        </Form.Item>

        <Form.Item label="Cab Id">
          <Input value={selectedRowInfo?.cabid} readOnly />
        </Form.Item>

        <Form.Item
          name="km"
          label="Km"
          rules={[{ required: true, type: "number" }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            readOnly
          />
        </Form.Item>

        <Form.Item
          name="time"
          label="Time"
          rules={[{ required: true, type: "number" }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            readOnly
          />
        </Form.Item>

        <Form.Item
          name="fare"
          label="Fare"
          rules={[{ required: true }]}
        >
          <InputNumber
            style={{ width: "100%" }}
            readOnly
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            onClick={completetrip}
          >
            Complete Trip
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Tripclose;